export default {
  register: 'Welcome.  Get Started Free Today.',
  submit: 'Submit',
  weakPasswordError: 'Password must be at least 6 characters',
  unavailableEmailError: 'This email is unavailable',
  toLogin: 'Already a member? Login here'
};



// WEBPACK FOOTER //
// ./src/views/guest/register/Register.messages.js